<template>
	<div class="personalDetailContent">
		<div class="title"><span>{{title}}</span></div>
		<div>
			<!-- <sw-table :pagination="false" :tableName="'sw-table-example-1'" :tableData="tableData" :tableTitle="tableTitle" :hasOperation="false"></sw-table> -->
			<el-table
				:data="tableData"
				style="width: 100%" 
				stripe>
				<el-table-column
				 v-for="(item, index) in tableTitle"
					:prop="item.prop"
					:label="item.label"
					:show-overflow-tooltip="true"
					:key="index">
				</el-table-column>
			</el-table>
		</div>
	</div>
</template>

<script>
	import { getPersonalDetail } from '@/api/shangcai.js'
export default {
	name: 'personalDetailList',
	data() {
		return {
			type:'',
			username: '',
			title: '',
			tableData: [],
			tableTitle: []
			// tableTitle: [{"prop":"LSH","label":"流水号"},{"prop":"RYBH","label":"学工号"},{"prop":"KH","label":"一卡通号"},{"prop":"WLKH","label":"一卡通物理卡号"},{"prop":"XM","label":"姓名"},{"prop":"JYE","label":"交易额"},{"prop":"YE","label":"余额"},{"prop":"JYSJ","label":"交易时间"},{"prop":"XFLX","label":"消费类型"},{"prop":"ND","label":"年度"},{"prop":"SH","label":"消费地点"},{"prop":"ACCSTATUS","label":"卡状态"}],
			
		};
	},
	created() {
		this.handleUrlInfo();
		this.handPersonalDetailList();
	},
	methods: {
		// 获取链接后拼接参数
		handleUrlInfo() {
			let urlInfo = window.location.href;
			let urlParams = urlInfo.split("?");
			let urlParamsList = urlParams[1].split("&");
			this.type = urlParamsList[0].split("=")[1];
			this.username = urlParamsList[1].split("=")[1];
		},
		handPersonalDetailList(){
			let data = {
				type: this.type,
				username: this.username
			};
			getPersonalDetail(data).then((res) => {
				console.log(res.data);
				this.title = res.data.title;
				this.tableTitle = res.data.tableTitle;
				console.log(this.tableTitle);
				this.tableData = res.data.tableData;
			})
		}
	}
};
</script>

<style lang="scss">
.personalDetailContent {
	margin-right: 50px;
	.title {
		height: 32px;
		background: #f4f8fc;
		box-shadow: 0px -2px 3px rgba($color: #e7e7e7, $alpha: 0.5) inset;
		padding: 0 20px;
		box-sizing: border-box;
		font-size: 16px;
		font-weight: bold;
		line-height: 32px;
		margin-bottom: 20px;
		span {
			padding-left: 7px;
			border-left: 3px solid #3394e1;
			color: rgba(2, 21, 37, 0.45);
		}
	}
}
</style>